"use client"

import { Marquee } from "@shared/ui/landing/marquee"
import { StatusTag } from "@shared/ui/landing/status-tag"
import { SectionContainer } from "@shared/ui/landing/section-container"

import { liveOrders } from "@/lib/live-data"
import { useTranslations } from "@/lib/i18n/client"

export function OrdersTickerSection() {
  const t = useTranslations("orders")

  const statusVariant = {
    completed: "success",
    processing: "warning",
    confirmed: "info",
  } as const

  return (
    <SectionContainer className="py-12">
      <div className="text-center">
        <h2 className="text-2xl font-bold text-brand">{t("title")}</h2>
        <p className="mt-2 text-sm text-muted-foreground">{t("subtitle")}</p>
      </div>

      <div className="mt-8 overflow-hidden rounded-2xl border border-brand bg-white py-4">
        <Marquee
          items={liveOrders.map((order) => (
            <div
              key={order.id}
              className="flex min-w-[280px] items-center gap-4 rounded-xl border border-brand/50 bg-white px-4 py-3 shadow-sm"
            >
              <div className="min-w-0 flex-1">
                <div className="flex items-center gap-2">
                  <span className="text-xs font-medium text-brand">{order.id}</span>
                  <StatusTag variant={statusVariant[order.status]}>
                    {t(`status.${order.status}`)}
                  </StatusTag>
                </div>
                <p className="mt-1 truncate font-mono text-xs text-muted-foreground">
                  {order.address}
                </p>
              </div>
              <div className="text-right">
                <p className="text-sm font-semibold text-brand">
                  {order.amount.toLocaleString()} USDT
                </p>
                <p className="text-xs text-muted-foreground">
                  {t(`sides.${order.side}`)} · {order.timestamp}
                </p>
              </div>
            </div>
          ))}
          speed={40}
        />
      </div>
    </SectionContainer>
  )
}
